import * as realUnbxdMapper from '../../unbxd/mapper';
export class UnbxdMockMapper {
    isValidResponse(rawData) {
        return rawData.response && rawData.response.products;
    }
    mapProducts(products) {
        // Direct reuse of real Unbxd mapper
        return realUnbxdMapper.mapProducts(products);
    }
    mapFilters(facets, currentFilters) {
        // Direct reuse of real Unbxd mapper
        return realUnbxdMapper.mapFilters(facets, currentFilters);
    }
    mapMeta(rawData, page, pageSize) {
        // Direct reuse of real Unbxd mapper
        return realUnbxdMapper.mapMeta(rawData, page);
    }
}
